// @flow

export const getPosts = state => state.newsList.posts
export const initiating = state => state.newsList.initiating
export const loadingMore = state => state.newsList.loadingMore
export const hasMore = state => state.newsList.hasMore
export const getPostCount = state =>
  state.newsList.postsCount || getPosts(state).length
